export function getInsuranceName(insurance) {
  if (!insurance.insured_id) {
    return insurance.is_primary
      ? '[Primary Insurance]'
      : '[Secondary Insurance]'
  } else {
    return `${insurance.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name} (Insurance)`
  }
}
